import React from 'react'

type Props = {}

export const PageSkeleton = (props: Props) => {
  return (
    <div className="container" aria-hidden="true">
      <h5 className="card-title placeholder-glow">
        <span className="placeholder col-6"></span>
      </h5>
      <p className="placeholder-glow">
        <span className="placeholder col-7"></span>
        <span className="placeholder col-5"></span>
      </p>
      {/* <button className="btn btn-primary disabled placeholder col-4"></button> */}
    </div>
  )
}

export const AccountSkeleton = (props: Props) => {
  return (
    <div className="container" aria-hidden="true">
      <div className="placeholder-glow">
        <span className="rounded-circle placeholder col-2 me-3" style={{ width: 46, height: 46 }}></span>

        <span className="placeholder col-5"></span>
      </div>
    </div>
  )
}

export const TableSkeleton = ({ colSpan = 5 }: { colSpan?: number }) => {
  return (
    <>
      <tr>
        <td colSpan={colSpan} className="placeholder-glow">
          <span className="placeholder col-12"></span>
        </td>
      </tr>
      <tr>
        <td colSpan={colSpan} className="placeholder-glow"><span className="placeholder col-12"></span></td>
      </tr>
    </>
  )
}

export const CardSkeleton = () => {
  return (
    <div className="card rounded-4 border-2 selectable-card-skeleton">
      <div className="card-body">
        <div className="placeholder-glow mb-3">
          <h5 className="card-title mb-2">
            <span className="placeholder col-6"></span>
          </h5>
          <p>
            <span className="placeholder col-8"></span>
          </p>
          <p>
            <span className="placeholder col-4"></span>{' '}
            <span className="placeholder col-2"></span>
          </p>
        </div>

        <div className="placeholder-glow mt-4">
          <ul className="list-unstyled">
            <li className="mb-2"><span className="placeholder col-10"></span></li>
            <li className="mb-2"><span className="placeholder col-8"></span></li>
            <li className="mb-2"><span className="placeholder col-9"></span></li>
            <li className="mb-2"><span className="placeholder col-9"></span></li>
            <li className="mb-2"><span className="placeholder col-8"></span></li>
          </ul>
        </div>

        <div className="placeholder-glow mt-5">
          <div className="placeholder col-12 rounded py-3"></div>
        </div>
      </div>
    </div>
  )
}

export const SmallCardSkeleton = () => (
  <div className="rounded-4 border-2 selectable-card-skeleton">
    <div className="placeholder-glow mb-3">
      <h5 className="card-title mb-2">
        <span className="placeholder col-6"></span>
      </h5>
      <p>
        <span className="placeholder col-12"></span>
      </p>
    </div>
  </div>
);

export const ModalFormSkeleton = () => (
  <div className="rounded-4 border-2">
    <div className="modal-body">
      <div className="placeholder-glow">
        <div className="mb-3">
          <span className="placeholder col-4 mb-2"></span>
          <span className="placeholder col-12"></span>
        </div>
        <div className="mb-3">
          <span className="placeholder col-3 mb-2"></span>
          <span className="placeholder col-12"></span>
        </div>
        <div className="mb-3">
          <span className="placeholder col-5 mb-2"></span>
          <span className="placeholder col-12"></span>
        </div>
      </div>
    </div>
  </div>
);
